var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAlert',{staticClass:"tw-mt-2",attrs:{"theme":"info"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.employmentAllowanceHasNoEffectText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }